import isEmpty from "lodash/isEmpty"
import forEach from "lodash/forEach"

/* selectViolationsList - селектор  для получения списка ошибок определенной категории - type */

export function selectViolationsList(state, type) {
  const idList = []
  const getValidType = validateData => {
    let validateType = false
    forEach(validateData, value => {
      if (value.level === `ERROR`) {
        validateType = true
        return false
      }
      return true
    })
    return validateType
  }
  // Проверяем наличии ошибок переданного типа (eventViolations/resourceViolations/planViolations)
  if (
    state.validate.data &&
    state.validate.data[type] &&
    !isEmpty(state.validate.data[type])
  ) {
    state.validate.data[type].map(item => {
      // У каждого типа (type) своя структура - event/resource/plan
      if (item.event) {
        idList[item.event.uuid] = {
          error: getValidType(item.violations),
          violations: item.violations,
        }
      }
      if (item.resource) {
        idList[item.resource.uuid] = {
          error: getValidType(item.violations),
          violations: item.violations,
        }
      }
      if (item.plan) {
        idList[item.plan.uuid] = {
          error: getValidType(item.violations),
          violations: item.violations,
        }
      }
      return item
    })
  }
  return idList
}

/* validateData - селектор  для получения data как она приходит с бэка или по определенной категории - key */

export default function selectValidate(state, key) {
  return key ? state.validate.data[key] : state.validate.data
}
